import { StarIcon } from '@chakra-ui/icons';
import { Box, Card, IconButton, useDisclosure } from '@chakra-ui/react';

import { H2 } from '@/elements';

import Impersonate from './Impersonate';
import RunJobs from './RunJobs';

const AdminPanel = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const offsetLeft = isOpen ? `0px` : `100%`;

  return (
    <>
      <IconButton
        aria-label='admin-button'
        icon={<StarIcon />}
        onClick={() => {
          isOpen ? onClose() : onOpen();
        }}
        position={`fixed`}
        bottom={{
          base: '20px',
          lg: '100px',
        }}
        right={`20px`}
        zIndex={999}
        width={'fit-content'}
      />
      <Box
        right={0}
        bottom={{
          base: '100px',
          lg: '180px',
        }}
        width='320px'
        transition={`all 0.3s`}
        transform={`translate(${offsetLeft}, 0)`}
        position={`fixed`}
        bg={'white'}
        zIndex={999}
        shadow={'lg'}
        borderRadius={'12px'}
      >
        <Card padding={3} borderRadius={'12px'}>
          <H2 mb='lg' fontSize='24px'>
            Admin Panel
          </H2>
          <Box gap={'md'} display={'flex'} flexDirection={'column'}>
            <Impersonate />
            <hr />
            <RunJobs />
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default AdminPanel;
